<template>
  <div class="resume-documents-list">
    <div v-for="(document, index) in documents"
         :key="document.passport_page_id + '-' + index"
         :class="{'_viewed': viewedPassportsIds.includes(document.passport_page.id)}"
         class="resume-documents-list__item">
      <div class="resume-documents-list__item-checkbox-wrap">
        <BaseCheckbox :checked="isSelected(document)"
                      @input="onSelectToggle(document)"
                      class="resume-documents-list__item-checkbox"/>
      </div>
      <FileShow :value="document.passport_page"
                @click.prevent="onShowGallery(index)"
                class="resume-documents-list__item-image"/>
      <div class="resume-documents-list__item-name">
        {{ document.passport_page_item.page_name }}
      </div>
    </div>

    <CoolLightBox v-if="galleryItems.length"
                  :items="galleryItems"
                  srcName="path"
                  :index="galleryIndex"
                  @on-change="onPassportGalleryIndexChange"
                  @close="galleryIndex = null"/>
  </div>
</template>

<script>
  import FileShow from '@/components/FileShow'
  import {http} from '@/axios'

  const CoolLightBox = () => import(/* webpackChunkName: "light-box" */ '../../components/CoolLightBox')


  export default {
    name: 'ResumeDownloadedDocumentsGroupList',
    components: {
      FileShow,
      CoolLightBox
    },
    props: {
      documents: {
        type: Array,
      },
      viewedPassportPages: {
        type: Array,
        default: () => ([])
      },
      selectedDocumentsIds: Array
    },
    data(vm) {
      return {
        galleryIndex: null,
        viewedPassportsIds: vm.viewedPassportPages.map(p => +p),
      }
    },
    computed: {
      galleryItems() {
        return this.documents.map(item => item.passport_page)
      }
    },
    methods: {
      isSelected(document) {
        return this.selectedDocumentsIds.includes(document.passport_page.section_id)
      },
      onSelectToggle(document) {
        this.$emit('toggle-select', document.passport_page.section_id)
      },
      onShowGallery(index) {
        this.galleryIndex = index
        this.onPassportGalleryIndexChange(index)
      },
      onPassportGalleryIndexChange(index) {
        const id = this.galleryItems[index].id

        if (this.viewedPassportsIds.includes(id)) return

        this.viewedPassportsIds.push(id)
        this.savePassportIdsToViewed(id)
      },
      savePassportIdsToViewed(id) {
        http.post('api/new-resume/set-passport-viewed', {id})
      }
    }
  }
</script>

<style lang="less">

</style>
